module.exports = __webpack_public_path__ + "assets/img/33_842.7afad67a.jpg";